import React from 'react';
import classnames from 'classnames';
import { getLocale } from 'umi';
import TextBubbles from '@home/components/TextBubbles';
import { getOptionText } from '@intelligence/utils/topchartsUtils';

import type { IBaseProps, ICommonOptionCategory } from '@intelligence/types/common';

// 引用ReleaseDateByPlatform组件的样式作为基础样式
import '@intelligence/pages/TopCharts/components/DetailsPage/ReleaseDateByPlatform/index.scss';
import '@intelligence/pages/TopCharts/components/DetailsPage/TagsCard/index.scss';

interface ITagsCardProps extends IBaseProps {
  title: string | React.ReactElement;
  noDataTip: string;
  categoryAlias?: {
    [key: string]: string;
  };
  list: ICommonOptionCategory[];
  // 第一个参数为 左侧分类的value，第二个参数为右侧点击的tag的value
  onClick?: (categoryValue: string, tag: ICommonOptionCategory) => void;
}

const TagsCard: React.FC<ITagsCardProps> = (props) => {
  const { title, noDataTip, categoryAlias, list, onClick, style, className } = props;

  const locale = getLocale();

  const isNoData = !(list?.length > 0);

  const handleTagClick = (categoryValue: string, tag: ICommonOptionCategory) => {
    onClick?.(categoryValue, tag);
  };

  const renderTags = (tagCategoryValue: string, tags?: ICommonOptionCategory[]) => {
    if (!Array.isArray(tags) || !tags.length) {
      return (
        <div className="dbi-release-data-item--placeholder">-</div>
      );
    }

    return tags.map((tag) => {
      const tagValue = tag?.value;
      return (
        <TextBubbles
          className="dbi-release-data-item"
          key={tagValue}
          text={getOptionText(locale, tag)}
          onClick={(e: React.SyntheticEvent<Element>) => {
            e?.stopPropagation();
            e?.preventDefault();
            handleTagClick(tagCategoryValue, tag);
          }}
        />
      );
    });
  };

  return (
    <div style={style} className={classnames('dbi-release-data dbi-tags-card', className)}>
      <div className="dbi-release-data-title dbi-tags-card-title">{title}</div>
      {isNoData && (
        <span className="dbi-tags-card-no-data">{noDataTip}</span>
      )}
      {isNoData || (
        <div className="dbi-release-data-context dbi-targs-card-context">
          {list?.map((tagCategory) => {
            const tagCategoryValue = tagCategory?.value;
            let tagCategoryName = getOptionText(locale, tagCategory);
            tagCategoryName = categoryAlias?.[tagCategoryName] || tagCategoryName;
            return (
              <div className="dbi-release-data-row" key={tagCategoryValue}>
                <TextBubbles className="dbi-release-data-label" text={tagCategoryName} />
                <div className="dbi-release-data-text">
                  {renderTags(tagCategoryValue, tagCategory?.children)}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default React.memo(TagsCard);
